import Lang from 'src/libraries/language';
import yup from 'src/libraries/validator.library';

export const FileSchema = yup
  .object({
    id: yup.number(), // For forms
    uploadId: yup.number().nullable(),
    requestId: yup.number(),
    fileName: yup.string().required().typeError(Lang.MSG_ERROR_REQUIRED),
    docName: yup.string().nullable(),
    app: yup.string(),
    container: yup.string(),
    environment: yup.string(),
    message: yup.string(),
    uploadTypeId: yup.number().nullable(),
    uploadedBy: yup.string().nullable(),
    uploadDate: yup.string().nullable(),
  })
  .defined();

export const FileFormSchema = yup.object({
  fileName: yup.string().required(),
  file: yup.mixed().required(),
});

export const FileDownloadPayloadSchema = yup
  .object({
    fileUrl: yup.string().required(),
  })
  .defined();

export const FileUploadListPayload = yup
  .object({
    count: yup.number(),
    rows: yup.array().of(FileSchema.clone()),
  })
  .defined();

export const FileDeletePayload = yup
  .object({
    success: yup.number(),
  })
  .defined();

export type IFile = yup.InferType<typeof FileSchema>;
